const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins
const { debounce } = window.BAO.Utils

class AnnouncementBar extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.hasAttribute('data-date')) {
      const closedDate = new Date(this.getAttribute('data-date'))
        .toISOString()
        .slice(0, 10)
      const currentDate = new Date().toISOString().slice(0, 10)

      if (currentDate > closedDate) {
        this.deleteCartAttribute()
      }
    }

    if (this.ariaHidden) return

    this.setAttribute('aria-hidden', 'false')

    this.setHeight = this.setHeight.bind(this)

    window.addEventListener('resize', this.setHeight)
    this.setHeight()

    this.setVisibleHeight()

    if (this.els.slide.elements.length < 2) return

    this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.setVisibleHeight = this.setVisibleHeight.bind(this)

    this.listeners.add(window, 'scroll', debounce(this.setVisibleHeight, 200))

    this.handleClose = this.handleClose.bind(this)

    if (this.els?.close?.elements) {
      this.els.close.elements.forEach(closeEl => {
        this.listeners.add(closeEl, 'click', this.handleClose)
      })
    }
  }

  hideAnnouncementBar () {
    this.setAttribute('aria-hidden', 'true')

    document.documentElement.style.setProperty(
      '--Announcement_VisibleHeight',
      `0px`,
    )

    document.documentElement.style.setProperty('--Announcement_Height', `0px`)
  }

  async handleClose () {
    this.hideAnnouncementBar()

    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: new Date().toISOString().slice(0, 10),
        },
      }),
    })
  }

  async deleteCartAttribute () {
    // eslint-disable-next-line compat/compat
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        attributes: {
          [this.storageName]: null,
        },
      }),
    })
  }

  setVisibleHeight () {
    this.visibleHeight =
      this.els.body.element.offsetHeight - window.scrollY > 0
        ? this.els.body.element.offsetHeight - window.scrollY
        : 0

    document.documentElement.style.setProperty(
      '--Announcement_VisibleHeight',
      `${this.visibleHeight}px`,
    )
  }

  setHeight () {
    document.documentElement.style.setProperty(
      '--Announcement_Height',
      `${this.els.body.element.offsetHeight}px`,
    )
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [useAutoplay(4, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }

  get storageName () {
    return 'hide_announcement_date'
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar)
}
